import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
import styled from 'styled-components';
export const TdNoBorder = styled.td.withConfig({
  displayName: "styles__TdNoBorder",
  componentId: "d0ewyb-0"
})(["border-left:none !important;border-right:none !important;padding-top:15px !important;padding-bottom:15px !important;"]);
export const HorizontalFlipItem = styled.div.withConfig({
  displayName: "styles__HorizontalFlipItem",
  componentId: "d0ewyb-1"
})(["transform:scaleY(-1);display:inline-block;line-height:50%;"]);
export const TableLoadingBarContainer = styled.div.withConfig({
  displayName: "styles__TableLoadingBarContainer",
  componentId: "d0ewyb-2"
})(["position:relative;z-index:2;"]);
export const LoadingTableRow = styled.div.withConfig({
  displayName: "styles__LoadingTableRow",
  componentId: "d0ewyb-3"
})(["max-width:100%;height:20px;background:linear-gradient(to right,", ",", " 20%,", " 40%);background-size:1200;"], GYPSUM, KOALA, GYPSUM);
export const COL_50 = styled.col.withConfig({
  displayName: "styles__COL_50",
  componentId: "d0ewyb-4"
})(["width:50px;"]);
export const COL_100 = styled.col.withConfig({
  displayName: "styles__COL_100",
  componentId: "d0ewyb-5"
})(["width:100px;"]);